import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
interface Occurrences {
  delay: number;
  region: string;
}
export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [labels, setLabels] = useState<string[]>([]);
  const [dataChartFormatted, setDataChartFormatted] = useState<string[]>([]);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const { mode } = useParams();

  function convertSecDatetime(secs: number) {
    if (secs % 3600 !== 0 && secs > 3600) {
      const hours =
        Math.floor(secs / 3600) < 10
          ? "0" + Math.floor(secs / 3600)
          : Math.floor(secs / 3600);
      const minutes =
        Math.floor((secs % 3600) / 60) < 10
          ? "0" + Math.floor((secs % 3600) / 60)
          : Math.floor((secs % 3600) / 60);
      return hours + "h" + minutes;
    } else if (secs >= 3600) {
      const hours =
        Math.floor(secs / 3600) < 10
          ? "0" + Math.floor(secs / 3600)
          : Math.floor(secs / 3600);
      return hours + "h";
    } else {
      const minutes =
        Math.floor(secs / 60) < 10
          ? "0" + Math.floor(secs / 60)
          : Math.floor(secs / 60);
      return minutes + "m";
    }
  }
  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-region-avg" });
    const dl_fmt: string[] = [],
      dl: number[] = [],
      rg: string[] = [];
    data.delays.forEach((route: Occurrences) => {
      dl_fmt.push(convertSecDatetime(route.delay));
      dl.push(route.delay);
      rg.push(route.region);
    });
    if (dl && dl.length !== 0) {
      const fakesCol = Math.floor(sizes.height / dl.length / 230);
      if (fakesCol > 0) {
        for (let i = 1; i <= fakesCol; i++) {
          dl.push(0);
        }
      }
    }
    setDataChartFormatted(dl_fmt);
    setLabels(rg);
    setDataChart(dl);
  }, [data]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-region-avg" });

    if (sizes.width < 345) {
      setFontSize({ id: "chart-region-avg", width: sizes.width });
    }
    if (dataChart && dataChart.length > 10) {
      if (sizes.height > dataChart.length * 32) {
        setHeightChart(sizes.height - 40);
      } else {
        setHeightChart(dataChart.length * 35);
      }
    } else {
      setHeightChart(sizes.height - 40);
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [dataChart]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          if (
            mode === "view" &&
            componentProperty({
              id: "chartRegionAvg",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartRegionAvg", {
                redirectTowerToDelays: true,
                routeDelay: '1',
                region: labels[config.dataPointIndex]
              }),
              "_blank"
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    colors: [
      "#B2D4EF",
      "#E9B825",
      "#FFAF8F",
      "#5894C2",
      "#FFDA6B",
      "#E95D25",
      "#80B3DA",
      "#FFE38F",
    ],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        if (labels[opt.dataPointIndex]) {
          return (
            labels[opt.dataPointIndex] +
            ":  " +
            dataChartFormatted[opt.dataPointIndex]
          );
        }
        return "";
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      labels: {
        formatter: function (value) {
          return convertSecDatetime(parseInt(value)).toString();
        },
      },
      max: Math.max(...dataChart),
      range: 7,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };
  const series = [
    {
      data: dataChart,
    },
  ];

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={"Atrasos - Média por região"}
        clickable={componentProperty({
          id: "chartRegionAvg",
          property: "redirect",
        })}
        id="chart-region-avg"
      />

      <div
        id={
          dataChart &&
          (dataChart.length <= 10 ||
            getSizesComponent({ id: "chart-region-avg" }).height >
              dataChart.length * 32)
            ? "fixedBox"
            : "scrollBox"
        }
      >
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
